<template>
  <el-dialog
    title="新增分类"
    :visible.sync="visible"
    width="642px"
    :before-close="handleClose"
  >
    <ClassItem
      v-for="(item, index) in list"
      :key="item._id"
      :data="item"
      @add="handleAddClass"
      @remove="handleRemove(index)"
      @movetop="handleMoveTop(index)"
      @movedown="handleMoveDown(index)"
    />
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleComfirm" :loading="loading"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>
<script>
import ClassItem from "./ClassItem.vue";
export default {
  components: { ClassItem },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      list: [],
      loading: false
    };
  },
  created() {
    this.handleAddClass();
  },
  methods: {
    handleMoveDown(index) {
      if(index === this.list.length - 1) return
      [this.list[index], this.list[index + 1]] = [this.list[index + 1], this.list[index]]
      this.list.push() // 更新视图
    },
    handleMoveTop(index) {
      if(index === 0) return
      [this.list[index], this.list[index - 1]] = [this.list[index - 1], this.list[index]]
      this.list.push() // 更新视图
    },
    handleRemove(index) {
      if(this.list.length <= 1) return
      this.list.splice(index, 1);
    },
    handleAddClass() {
      this.list.push({
        category_name: "",
        _id: new Date().getTime(),
        children: [
          {
            category_name: "",
            _id: new Date().getTime() + "children"
          }
        ]
      });
    },
    createClass() {
      return lib.tmsapi.post({
        api: 'api/test/material_category/batch_add',
        data: {
          items: JSON.stringify(this.list)
        }
      })
    },
    async handleComfirm() {
      this.loading = true
      try {
        await this.createClass()
        this.$emit("success");
        this.handleClose();
      } catch (error) {
          error && this.$message.error(error.msg||error.message)
      }
      this.loading = false
    },
    handleClose() {
      this.$emit('update:visible', false)
    }
  }
};
</script>
<style scoped></style>
